export const record_limits = [25,50,75,100]
export const default_limit = 25;